import { action } from "satcheljs";

import type { OwaNovaActionUnion } from "../types";

export const onMessageExtensionAddinsTrigger = action("onMessageExtensionAddinsTrigger", event => ({
    event,
    owaType: "messageExtensions",
})) as OwaNovaActionUnion<"messageExtensions">;
